import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { PlanSubjectRequest, PlanSubjectResponse } from "../../models/dtos";
import { plansApi } from "../plans/plansApi";

export const planSubjectsApi = createApi({
  reducerPath: "planSubjectsApi",
  baseQuery: baseAuthQuery("planSubjects"),
  tagTypes: ["Plan", "PlanSubject"],
  endpoints: (builder) => ({
    updatePlanSubject: builder.mutation<ApiResponse<PlanSubjectResponse>, Partial<PlanSubjectRequest>>({
      query: (body) => ({
        url: "CreateOrUpdate",
        method: "POST",
        body,
      }),
      async onQueryStarted({ planId }, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(plansApi.util.invalidateTags([{ type: "Plan", id: planId }]));
      },
    }),
    deletePlanSubject: builder.mutation<ApiResponse<PlanSubjectResponse>, number>({
      query: (id) => ({
        url: `Delete/${id}`,
        method: "GET",
      }),
    }),
  }),
});
